import LoginDashBoard from "./LoginDashBoard";
import { Form, Input, Modal } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";
import { resetPassword } from "../../apis/loginApis/loginEndpoint";
import { openNotification } from "../../utils/UI/openNotification";

export default function ResetPassword() {
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = queryString.parse(location.search);
  const token = queryParams.token;

  const onFinish = (values: any) => {
    resetPasswordHandle(values);
  };

  const onFinishFailed = (errorInfo: object) => {
  };

  const resetPasswordHandle = async (values: any) => {
    try {
      if (!values) throw new Error("Enter valid password.");
      const payload = { password: values.password, token };
      const res = await resetPassword(payload);
      if (!res.status) throw res;
      openNotification("success", {
        message: res?.message || "Passworn reset successfully!",
      });
      navigate("/login");
    } catch (err: any) {
      openNotification("error", {
        message: err?.message || "Something went wrong",
      });
    }
  };
  return (
    <LoginDashBoard>
      <div className="flex justify-center w-full"></div>
      <Form
        name="login"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <div className="flex justify-between items-center w-full">
          <span className="text-lightGrey text-sm font-poppins font-normal break-words">
            {"Enter New password"}:
          </span>
        </div>

        <Form.Item
          name={"password"}
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Input
            type={"password"}
            className="md:min-h-[55px] max-h-[29px] text-xl text-lightGrey rounded-lg border border-inputBorder"
          />
        </Form.Item>

        <Form.Item className="mt-5 flex justify-center">
          <button
            type="submit"
            className="md:min-w-[415px] md:min-h-[55px] min-w-[220.92px] min-h-[29.62px] rounded-md bg-yellow hover:bg-darkyellow   "
          >
            <span className="text-white text-base font-poppins font-bold break-words ">
              Submit
            </span>
          </button>
        </Form.Item>
      </Form>
    </LoginDashBoard>
  );
}
